import { BrowserRouter, Routes, Route, NavLink, Navigate, useLocation } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { ToastProvider } from './components/Toast';
import ErrorBoundary from './components/ErrorBoundary';
import UploadManager from './components/UploadManager';
import SongLibrary from './components/SongLibrary';
import SongConfiguration from './components/SongConfiguration';
import SetListEditor from './components/SetListEditor';
import PerformanceView from './components/PerformanceView';
import SetlistPerformanceView from './components/SetlistPerformanceView';

function NotFoundPage() {
  return <div className="page"><h2>404</h2><p>Page not found.</p></div>;
}

/** Hides the nav bar on performance routes for a distraction-free view. */
function NavBar() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/performance/')) return null;
  return (
    <nav className="nav-bar" role="navigation" aria-label="Main navigation">
      <NavLink to="/songs" className="nav-title">Lyrics Prompter</NavLink>
      <NavLink to="/upload">Upload</NavLink>
      <NavLink to="/songs">Songs</NavLink>
      <NavLink to="/setlists">Set Lists</NavLink>
    </nav>
  );
}

function App() {
  return (
    <AppProvider>
      <ToastProvider>
        <BrowserRouter>
          <NavBar />
          <main>
            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<Navigate to="/songs" replace />} />
                <Route path="/upload" element={<UploadManager />} />
                <Route path="/songs" element={<SongLibrary />} />
                <Route path="/songs/:songId/edit" element={<SongConfiguration />} />
                <Route path="/setlists" element={<SetListEditor />} />
                <Route path="/performance/setlist/:setListId" element={<SetlistPerformanceView />} />
                <Route path="/performance/:songId" element={<PerformanceView />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </ErrorBoundary>
          </main>
        </BrowserRouter>
      </ToastProvider>
    </AppProvider>
  );
}

export default App;
